/**
 * <s-flip-card> — Manages 3D flip card interaction on touch and pointer devices.
 * On hover devices, CSS hover triggers the flip and click navigates to the product.
 * On touch devices (hover: none), the first tap flips the card to reveal the product
 * and price, and a second tap navigates to the product. Tapping outside unfurls/flips back.
 */
class SFlipCard extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const link = this.querySelector('a');
    if (!link) return;

    link.addEventListener(
      'click',
      (event) => {
        // Desktop / pointer with hover capability uses hover to flip, normal click navigates
        if (window.matchMedia('(hover: hover)').matches) return;

        const isFlipped = this.classList.contains('is-flipped');
        if (!isFlipped) {
          event.preventDefault();
          // Reset other flipped cards so only one is open at a time
          document.querySelectorAll('s-flip-card.is-flipped').forEach((other) => {
            if (other !== this) other.classList.remove('is-flipped');
          });
          this.classList.add('is-flipped');
        }
      },
      { signal }
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!this.contains(event.target)) {
          this.classList.remove('is-flipped');
        }
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-flip-card')) {
  customElements.define('s-flip-card', SFlipCard);
}
